import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UtilitiesListComponent } from './features/utility-apps/utilities-list/utilities-list.component';
import { SsoDomainManagementComponent } from './features/utility-apps/sso-domain-management/sso-domain-management.component';
import { UtilityLayoutComponent } from './core/layout/utility-layout/utility-layout.component';
import { TenantLayoutComponent } from './core/layout/tenant-layout/tenant-layout.component';
import { TenantManagementComponent } from './features/tenant-management/tenant-management.component';

export const routes: Routes = [
  { path: '', redirectTo: 'utilities', pathMatch: 'full' },
  { 
    path: 'utilities',
    children: [
      { path: '', component: UtilitiesListComponent, canActivate: [MsalGuard] },
      { 
        path: 'sso-domain-management',
        component: UtilityLayoutComponent,
        canActivate: [MsalGuard],
        children: [
          { path: '', component: SsoDomainManagementComponent }
        ]
      },
    ]
  },
  { 
    path: 'tenant-management',
    component: TenantLayoutComponent,
    canActivate: [MsalGuard],
    children: [
      { path: ':tenantId', component: TenantManagementComponent }
    ]
  },
  { path: '**', redirectTo: 'utilities' }
];